import { PaymentElement } from '@stripe/react-stripe-js';
import { StripePaymentElementOptions } from '@stripe/stripe-js';

interface StripePaymentElementProps {
  onChange?: (event: { complete: boolean }) => void;
}

export default function StripePaymentElement({ onChange }: StripePaymentElementProps) {
  const paymentOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
      radios: true,
      spacedAccordionItems: false,
    },
    paymentMethodOrder: ['apple_pay', 'card'],
    defaultValues: {
      billingDetails: {
        address: {
          country: 'US',
        },
      },
    },
    fields: {
      billingDetails: {
        address: {
          country: 'never',
          postalCode: 'never',
        },
      },
    },
    terms: {
      card: 'never',
      applePay: 'never',
      googlePay: 'never',
      paypal: 'never',
      cashapp: 'never',
      usBankAccount: 'never',
    },
  };

  return <PaymentElement id="payment-element" options={paymentOptions} onChange={onChange} />;
}
